import { CarpayPaymentFlow } from '@customTypes/carpayPaymentFlow.interface'

export const SESSION_STORAGE_CARPAY_PAYMENT_FLOW = '@parkdepot/carpay_payment_flow'

export const SESSION_STORAGE_setCarpayPaymentFlow = (checkout: CarpayPaymentFlow) => {
    sessionStorage.setItem(SESSION_STORAGE_CARPAY_PAYMENT_FLOW, JSON.stringify(checkout))
}

export const SESSION_STORAGE_emptyCarpayPaymentFlow = () => {
    sessionStorage.removeItem(SESSION_STORAGE_CARPAY_PAYMENT_FLOW)
}

export const SESSION_STORAGE_getCarpayPaymentFlow = (): CarpayPaymentFlow | null => {
    const flowInfo = sessionStorage.getItem(SESSION_STORAGE_CARPAY_PAYMENT_FLOW)
    return flowInfo ? JSON.parse(flowInfo) : null
}
